import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IpList = _resolveComponent("IpList")!
  const _component_AddIp = _resolveComponent("AddIp")!
  const _component_EditIp = _resolveComponent("EditIp")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_IpList)
    ]),
    _createVNode(_component_AddIp),
    _createVNode(_component_EditIp)
  ], 64))
}